import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from './lib/queryClient';
import { initSentry } from './lib/sentry';
import { initAnalytics } from './lib/analytics';
import { installChunkReloadGuard } from './lib/chunkReload';
import { router } from './router';
import './index.css';

// Initialize error/perf monitoring as early as possible. No-op without a DSN.
initSentry();
// Initialize Firebase Analytics (GA4). No-op without Firebase config. Optional,
// so a failed lazy import (e.g. a stale chunk after a deploy) is swallowed
// rather than surfacing as an unhandled rejection.
void initAnalytics().catch(() => {});

// Reload once when a stale tab asks for a chunk the current build no longer
// has. See chunkReload.ts, including why it never reloads without storage.
installChunkReloadGuard();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
